/**
 * Mobile search bar
 */
 var component_mobile_search_bar = function(args) {

  // setup args
  var search_bar = args.search_bar;
  // Scope button query via aria-controls relationship with search bar's id
  var search_button = search_bar.id ?
    document.querySelector('[aria-controls="' + search_bar.id + '"]') :
    document.querySelector('.site-header__mobile-search-button');
  var input_field = search_bar.querySelector('.search-form__input');
  var submit_button = search_bar.querySelector('.search-form__submit');

  // validate
  if (!search_bar || !search_button) {
    return;
  }

  /**
   * Toggles the search button aria-expanded attribute value
   */
  function search_button_aria_expanded(expanded = false) {
    return expanded ? search_button.setAttribute('aria-expanded', true) : search_button.setAttribute('aria-expanded', false);
  }

  /**
   * Hides the search bar with closing animation
   */
  function hide_search_bar() {
    if (!search_bar.classList.contains('visible')) { return; }
    search_bar.classList.remove('visible');
    search_bar.classList.add('is-closing');
    search_button_aria_expanded();
    setTimeout(() => { search_bar.classList.remove('is-closing'); }, 250);
  }

  /**
   * Toggles the search bar visibility
   */
  function toggle_visibility(documentClick) {
    if (documentClick) {
      hide_search_bar();
      return;
    }

    if (search_bar.classList.contains('visible')) {
      hide_search_bar();
    } else {
      search_bar.classList.add('visible');
      search_button_aria_expanded(true);
      input_field.focus();
    }
  }

  /**
   * Init
   */
  function init() {

    // show the search bar when clicking the search button
    search_button.addEventListener('click', (e) => {
      e.stopPropagation();

      toggle_visibility();
    });

    // hide the search bar when clicking elsewhere
    document.addEventListener('click', (e) => {
      toggle_visibility(true);
    });

    // prevent the search bar from closing when clicking the submit button
    submit_button.addEventListener('click', (e) => e.stopPropagation());

    // prevent the search bar from closing when clicking the input field
    input_field.addEventListener('click', (e) => e.stopPropagation());

    return;
  }
  init();

  // make the call chainable
  return this;
};
